import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getFeatures, getProduct, getProductFilters } from "@/onboarding/features/product/selectors"
import routes from "@/routes"
import ButtonLink from "@/components/ButtonLink"

const AcceptProposedChangesButton: FC = () => {
  const {
    season: { id: seasonId },
  } = useSelector(getProduct)
  const { contractPeriodId } = useSelector(getProductFilters)
  const features = useSelector(getFeatures)

  if (!features.general.product.acceptContractPeriodDetailsRejection) {
    return null
  }

  return (
    <div>
      <ButtonLink
        label="Accept Proposed Changes"
        button={{ variant: "success" }}
        modal
        href={routes.new_onboarding_bidding_accept_contract_period_details_rejection_path({
          season_id: seasonId,
          contract_period_id: contractPeriodId,
        })}
      />
    </div>
  )
}

export default AcceptProposedChangesButton
